import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux'
import { addForward, removeForward, containsObject, formatPhone } from '../redux/FeedbackRedux';
import { parsePhoneNumberFromString } from 'libphonenumber-js';


class TextMessageForward extends React.Component {
    constructor(props) {
        super(props);
        this.addToCurrentForwards = this.addToCurrentForwards.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleNickname = this.handleNickname.bind(this);
        this.generateForwards = this.generateForwards.bind(this);
        this.removeFromForwards = this.removeFromForwards.bind(this);
        this.state = {value: '', all_forwards: [], nickname: ''};
    }

    addToCurrentForwards(forward, clearinput, event) {
        var recipient = forward.recipient;
        var nickname = (forward.nickname ? forward.nickname : null);
        var forward = {recipient: recipient, nickname: nickname};
        var phoneNumber = parsePhoneNumberFromString(recipient, 'US');
        if(!containsObject(forward,this.props.current_forwards) && phoneNumber){
            this.props.dispatch(addForward(forward));
        }
        if (clearinput) {
            this.setState({
                value: '',
                nickname: '',
                custom_text: ''
            })
        }
    }

    removeFromForwards(forward, event) {
        var recipient = forward.recipient;
        var nickname = (forward.nickname ? forward.nickname : null);
        this.props.dispatch(removeForward({recipient: recipient, nickname: nickname}))
    }

    generateForwards() {
        var allforwards = []
        if (this.props.feedback_contacts.length > 0) {
            this.props.feedback_contacts.map( function(forward,index) {
                if(forward.nickname) {
                    var jsx = <div key={index} onClick={this.addToCurrentForwards.bind(this,forward, false)} className="select-previous text-left text-capitalize btn btn-md btn-outline-secondary mr-1 mt-1 forward-buttons"><i className="far fa-user-plus mr-1 d-none d-sm-inline-block"></i> <span className="d-inline-block d-sm-none">+</span><span className='nn'>{forward.nickname + ": "}</span><span className='pn'>{forward.recipient}</span></div>
                } else {
                    var jsx = <div key={index} onClick={this.addToCurrentForwards.bind(this,forward, false)} className="select-previous text-left text-capitalize btn btn-md btn-outline-secondary mr-1 mt-1 forward-buttons"><i className="far fa-user-plus mr-1 d-none d-sm-inline-block"></i> <span className="d-inline-block d-sm-none">+</span><span className='pn'>{forward.recipient}</span></div>;
                }
                allforwards.push(jsx);
            }.bind(this));
        }
        this.setState({
            all_forwards: allforwards,
        })
        return allforwards;
    }

    handleKeyDown(event) {
        var update = event.target.value;
        if(this.state.value.length < update.length) {
            update = formatPhone(update);
        }
        this.setState({
            value: update
          });
    }

    handleNickname(event){
        this.setState({
            nickname: event.target.value
          });
    }

    componentDidMount() {
        this.generateForwards();
    }

    handleCheckboxChange(event) {
        if(event.target.checked) {
            jQuery('.hide-userinfo-icon i').removeClass('fa-eye');
            jQuery('.hide-userinfo-icon i').addClass('fa-eye-slash');
        } else {
            jQuery('.hide-userinfo-icon i').removeClass('fa-eye-slash');
            jQuery('.hide-userinfo-icon i').addClass('fa-eye');
        }
    }

    onTextChange(event) {
        this.props.handleTextInput(event);
        if (this.props.custom_text.length > event.target.value.length) {
            jQuery("#email_forward_textarea").css("height", "0px");
        }
        jQuery("#email_forward_textarea").css("height", Math.max(Math.min(document.getElementById("email_forward_textarea").scrollHeight, 170), 50) + "px");
    }

	render () {
        if (!this.props.feedback) return <></>;
        
        var body = <div className="simple-sms-field">
        <div className="previous mb-3"><h5 className="mb-2">{ __('Select From Text Message Contacts (gathered from Forward Recipients section)') }:</h5>

        {this.props.feedback_contacts.length > 0 &&
            this.props.feedback_contacts.map( function(value,index) {
                if (value.recipient && value.recipient != "") {
                    if(value.nickname) {
                        return <div key={index} onClick={this.addToCurrentForwards.bind(this,value, false)} className="select-previous text-left text-capitalize btn btn-md btn-outline-secondary mr-1 mt-1 forward-buttons"><i className="far fa-user-plus mr-1 d-none d-sm-inline-block"></i> <span className="d-inline-block d-sm-none">+</span> <span className='nn'>{value.nickname + ": "}&nbsp;</span><span className='pn'>{value.recipient}</span></div>
                    } else {
                        return <div key={index} onClick={this.addToCurrentForwards.bind(this,value, false)} className="select-previous text-left text-capitalize btn btn-md btn-outline-secondary mr-1 mt-1 forward-buttons"><i className="far fa-user-plus mr-1 d-none d-sm-inline-block"></i> <span className="d-inline-block d-sm-none">+</span> <span className='pn'>{value.recipient}</span></div>;
                    }
                } 
            }.bind(this))
        }

        {this.props.feedback_contacts.filter(function (value) {
            if (value.recipient && value.recipient != "") return true;
            return false;
        }).length < 1 &&
            "None"
        }

        </div>
        <div style={{display:'none'}} className="alert sms-alert" ></div>
        <h5 className="mt-3">Add New Recipient Mobile Number:</h5>

        <div className="row sms-row">
            <div className="col-sm-12 d-none d-sm-block">
                <div className="input-group feedback-form-control mb-0 border">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text"><i className="fas fa-phone-alt"></i></span>
                                    </div>
                                    <input type="text" onChange={this.handleKeyDown} value={this.state.value} className="form-control pl-1 w-80 forward-number" placeholder="Phone Number..." aria-label="Phone Number..." />
                                    <input type="text" onChange={this.handleNickname} value={this.state.nickname} className="form-control pl-2 forward-nickname" placeholder="Name (optional)" aria-label="Name (optional)" />
                                    <div className="input-group-append">
                                    <button className="btn btn-md btn-primary" onClick={this.addToCurrentForwards.bind(this,{recipient: this.state.value, nickname: this.state.nickname },true)} type="button"><i className="far fa-check-circle"></i> { __('Add') }</button>
                                    </div>
                </div>
            <p className="alert alert-sm alert-warning modal-warning mt-1">{ __('Please make sure to add contacts. If you are done, clear the fields') }.</p>
            </div>

            <div className="col-sm-12 d-block d-sm-none">
                <input type="text" onChange={this.handleKeyDown} value={this.state.value} className="form-control pl-1 w-80 forward-number border mt-1 input-group" placeholder="Phone Number..." aria-label="Phone Number..." />
                <input type="text" onChange={this.handleNickname} value={this.state.nickname} className="form-control pl-2 forward-nickname border mt-1 input-group" placeholder="Name (optional)" aria-label="Name (optional)" />
                <button className="btn btn-md btn-primary mt-2" onClick={this.addToCurrentForwards.bind(this,{recipient: this.state.value, nickname: this.state.nickname },true)} type="button"><i className="far fa-check-circle"></i> { __('Add') }</button>
            <p className="alert alert-sm alert-warning modal-warning mt-1">{ __('Please make sure to add contacts. If you are done, clear the fields') }.</p>
            </div>
            {/* <div className="col-sm-6"><input autoComplete="off" type="tel" className="form-control required phone_number valid" id="phone" name="phone" placeholder="Enter phone number"/></div>
            <div className="col-sm-4"><input type="text" name="nickname" className="form-control nickname" placeholder="Name (optional)"/></div> */}
        </div>

        <div className="row recipient-row mt-3">
            <div className="col-sm-12">
                <h5 className="mb-1">{ __('Currently Forwarding To') }:</h5>
            </div>
            <div className="col-sm-12 recipients">
                    {this.props.current_forwards.length == 0 &&
                        <span className="text-muted">None</span>
                    }

                    {this.props.current_forwards.map( function(value,index) {
                       return <div key={index} className="btn btn-md btn-outline-primary mr-1 mt-1 text-capitalize selected-phone-no" onClick={this.removeFromForwards.bind(this,value)}>{value.nickname?value.nickname+": ":null}{value.recipient} <i className="far fa-times ml-1 mr-1"></i></div>;
                    }.bind(this))}

            </div>
            <div className="col-sm-12 mt-2">
                <div className="input-group feedback-form-control mb-0 border">
                    <div className="input-group-prepend">
                        <span className="input-group-text"><i className="fas fa-comment"></i></span>
                    </div>
                    <textarea id="email_forward_textarea" 
                        style={{ resize: "none", minHeight: "50px" }} rows={1} 
                        onChange={this.onTextChange.bind(this)} className="form-control pl-1 w-80" 
                        value={this.props.custom_text} placeholder={ __('Add a Message') + "..." } aria-label="Add a Message..." />
                </div>
            </div>

            <div className="col-sm-12 mt-2">
                <div className="d-flex feedback-form-control mb-0">
                    <div className="input-group-prepend">
                        <span className="input-group-text hide-userinfo-icon"><i className="fas fa-eye"></i></span>
                    </div>
                    <label className="d-flex align-items-center mb-0"><span className="d-inline-block text-muted mr-2"> { __('Hide User Info In Forwarded Feedback') }</span><input type="checkbox" onChange={this.handleCheckboxChange.bind(this)} className="hide-userinfo ml-auto" id="hide-userinfo" /></label>
                </div>
            </div>
        </div>

        <input type="hidden" id="user_name" value={(this.props.feedback.user.firstname + " " +this.props.feedback.user.lastname?this.props.feedback.user.firstname + " " +this.props.feedback.user.lastname:"Anonymous")}/>
        <input type="hidden" id="user_id" value={this.props.feedback.user.user_id}/>
        <input type="hidden" id="feedback_id" value={this.props.feedback.feedback_id}/>
        <input type="hidden" id="business_id" value={this.props.feedback.business.business_id}/>
        <input type="hidden" id="company_name" value={this.props.feedback.business.name}/>
        </div>;

		return ( body );
	}
}

function mapStateToProps(state) {
	return { feedback:state.feedback_detail, current_forwards:state.current_forwards, feedback_contacts: state.feedback_detail !== null ? state.feedback_detail.forward_contacts : [] }
}

export default connect(mapStateToProps)(TextMessageForward)
